'use client';

export default function CatalogLayout({ children }: { children: React.ReactNode }) {
  return children;
}
